import styled from "@emotion/styled";
import {
  signupHeaderBreakpoint,
  signupHeaderHeightDesktop,
  signupHeaderHeightMobile
} from "src/constants/layout";

export const Header = styled.header`
  position: fixed;
  top: var(--safe-area-inset-top, 0px);
  left: 0;
  right: 0;
  z-index: 80;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  box-sizing: border-box;
  height: ${signupHeaderHeightMobile}px;
  padding: 0 var(--space-md, 24px);
  background: var(--color-cream);
  color: var(--color-charcoal);

  &::before {
    content: "";
    position: absolute;
    bottom: 100%;
    width: 100%;
    height: var(--safe-area-inset-top, 0px);
    background: inherit;
  }

  @media screen and (min-width: ${signupHeaderBreakpoint}px) {
    height: ${signupHeaderHeightDesktop}px;
  }

  body.nine-select-open & {
    opacity: 0;
    pointer-events: none;
  }
`;

export const Start = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const End = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1em;
`;

export const Brand = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
`;

export const BrandLogo = styled.span<{ $stacked: boolean }>`
  display: flex;
  color: inherit;

  > div {
    width: 158px;
    max-width: none;
  }

  svg {
    width: ${({ $stacked }) => ($stacked ? "75px" : "100%")};
    height: auto;
  }

  @media screen and (max-width: 480px) {
    svg {
      width: ${({ $stacked }) => ($stacked ? "60px" : "100%")};
    }
  }
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  min-height: 44px;
  min-width: 44px;
  padding: 0;
  border: 0;
  background: none;
  color: inherit;
  font: inherit;
  font-weight: 500;
  cursor: pointer;
`;

export const BackLabel = styled.span`
  display: none;

  @media screen and (min-width: 768px) {
    display: inline;
  }
`;

export const CustomLogo = styled.img`
  max-width: 300px;
  max-height: 43px;
`;

export const PartnerLogo = styled.div<{ $large: boolean }>`
  position: relative;
  width: ${({ $large }) => ($large ? 140 : 120)}px;
  height: ${({ $large }) => ($large ? 80 : 43)}px;
  margin-left: 1.6em;

  @media screen and (max-width: 480px) {
    height: ${({ $large }) => ($large ? 60 : 35)}px;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: left center;
  }

  &::before {
    content: "";
    position: absolute;
    left: -1.4em;
    top: 50%;
    width: 1.2px;
    height: 30px;
    background: var(--color-charcoal);
    transform: translateY(-50%);
  }
`;

export const ProgressTrack = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: var(--color-cream-dark);
`;

export const ProgressFill = styled.div<{ $progress: number }>`
  width: ${({ $progress }) =>
      Number.isFinite($progress) ? Math.min(100, Math.max(0, $progress)) : 0}%;
  height: 100%;
  background-image: linear-gradient(
    90deg,
    var(--color-sunrise-blue) 13.49%,
    var(--color-sunrise-pink) 51.22%,
    var(--color-sunrise-orange) 85.11%
  );
  background-size: 100vw;
  border-radius: 0 10px 10px 0;
  transition: width 0.5s cubic-bezier(0.22, 1, 0.36, 1);

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;
